export class JsxUtils {
  static readonly joinElements = (
    elements: React.ReactNode[],
    renderSeparator: (index: number) => React.ReactNode,
  ) => {
    return elements.reduce((acc: React.ReactNode[], element: React.ReactNode, index: number) => {
      if (acc.length > 0) {
        acc.push(renderSeparator(index));
      }

      acc.push(element);
      return acc;
    }, []);
  };
}
